import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { Component } from 'react';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { TOGGLE_DRAWER } from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import moment from 'moment';
import LinearProgress from '@material-ui/core/LinearProgress';
import { PnmacSectionListView, PnmacRowItem, PnmacRowHeader, PnmacCheckBox, PnmacUIButton, PnmacTabs, PnmacSelect, PnmacMediaQuery, PnmacMeta, PnmacNavigation, PnmacText, PnmacDatePicker, PnmacNativeFetch, PnmacModal, PnmacHtmlToNative, PnmacPagination } from "pnmac-universal-components";
import { View, Image, TouchableOpacity, Platform, Dimensions, Text } from 'react-native';
import styles from '../styles/styles.js';
import { getActiveFeatures, windowObject } from '../utils.js';
import { textStyle } from '../v2/theme';
import withPnmacTitle from '../withPnmacTitle';
import BannerView from '../v2/BannerView';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../events';
var DATE_FORMAT = "MM/DD/YYYY";
var useStyles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 500,
    margin: 'auto'
  },
  paper: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    margin: 20
  },
  consrm: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: -10,
    marginBottom: 10
  },
  root: {
    width: '90%',
    '& > * + *': {
      marginTop: 2
    }
  }
};
function TransitionsModal(_a) {
  var open = _a.open,
    closeModal = _a.closeModal,
    translations = _a.translations,
    matches = _a.matches;
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacModal, {
    open: open,
    style: {
      borderRadius: 10
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: __assign(__assign({}, useStyles.paper), {
      maxWidth: matches.small ? "90%" : 500,
      maxHeight: "60%",
      flexDirection: "column"
    })
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: 18,
      marginBottom: 20
    }
  }, translations === null || translations === void 0 ? void 0 : translations.ModalPopupRequestSentTitle)), /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, null, translations === null || translations === void 0 ? void 0 : translations.ModalPopupBody)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, null, translations === null || translations === void 0 ? void 0 : translations.ResearchInquiryText)), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, {
    idTag1: 'btnModalPopupOK',
    testID: "ModalPopupOkButtonText",
    style: {
      width: matches.small ? "90%" : "50%",
      marginTop: 50
    },
    mode: "contained",
    onPress: function () {
      closeModal();
    }
  }, translations === null || translations === void 0 ? void 0 : translations.ModalPopupOkButtonText)))));
}
function LinearBuffer() {
  var classes = useStyles;
  var _a = React.useState(0),
    completed = _a[0],
    setCompleted = _a[1];
  var _b = React.useState(10),
    buffer = _b[0],
    setBuffer = _b[1];
  var progress = React.useRef(function () {});
  React.useEffect(function () {
    progress.current = function () {
      if (completed > 100) {
        setCompleted(0);
        setBuffer(10);
      } else {
        var diff = Math.random() * 10;
        var diff2 = Math.random() * 10;
        setCompleted(completed + diff);
        setBuffer(completed + diff + diff2);
      }
    };
  });
  React.useEffect(function () {
    function tick() {
      progress.current();
    }
    var timer = setInterval(tick, 500);
    return function () {
      clearInterval(timer);
    };
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    variant: "buffer",
    value: completed,
    valueBuffer: buffer
  }));
}
var StateMentInfo = function (props) {
  var _a, _b, _c;
  var translations = props.translations,
    layout = props.layout,
    fetchPdf = props.fetchPdf,
    requestForms = props.requestForms,
    requestFormsQue = props.requestFormsQue,
    reqForm = props.reqForm,
    postRequest = props.postRequest,
    requestSubmitted = props.requestSubmitted,
    matches = props.matches,
    trackerSession = props.trackerSession;
  var language = layout.language;
  var DATAEXPANDABLE = [{
    title: translations.PanelTitle,
    data: [{
      header: translations.PanelTitle
    }]
  }].filter(function (s) {
    return s;
  });
  var col = React.useRef();
  var _d = React.useState(false),
    loading = _d[0],
    setLoading = _d[1];
  var _e = React.useState("Statements"),
    page = _e[0],
    setPage = _e[1];
  var _f = React.useState(moment()),
    fromDate = _f[0],
    setFromDate = _f[1];
  var _g = React.useState(moment()),
    toDate = _g[0],
    setToDate = _g[1];
  var _h = React.useState("All"),
    filterType = _h[0],
    setFilterType = _h[1];
  var _j = React.useState(null),
    filteredDocs = _j[0],
    setFilteredDocs = _j[1];
  var _k = React.useState(0),
    pagination = _k[0],
    setPagination = _k[1];
  var document = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.documents) === null || _a === void 0 ? void 0 : _a.whiteListedDoc) === null || _b === void 0 ? void 0 : _b.filter(function (e, i, self) {
    return e.documenetSku == page;
  });
  React.useEffect(function () {
    var _a, _b;
    setFilteredDocs(null);
    document = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.documents) === null || _a === void 0 ? void 0 : _a.whiteListedDoc) === null || _b === void 0 ? void 0 : _b.filter(function (e, i, self) {
      return e.documenetSku == page;
    });
  }, [layout === null || layout === void 0 ? void 0 : layout.documents]);
  var getBrowser = function () {
    var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: 'IE',
        version: tem[1] || ''
      };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return {
          name: 'Opera',
          version: tem[1]
        };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1]
    };
  };
  var browser = !layout.mobile ? getBrowser() : null;
  if (document) {
    document.sort(function (a, i) {
      return moment(i.createdUTC) - moment(a.createdUTC);
    });
  }
  var min = (_c = document === null || document === void 0 ? void 0 : document.filter(function (s) {
    return moment(s.createdUTC).isValid();
  })) === null || _c === void 0 ? void 0 : _c.sort(function (a, b) {
    return a.createdUTC - b.createdUTC;
  })[0];
  var go = true;
  if (document && document.length > 0 && fromDate.format(DATE_FORMAT) == moment().format(DATE_FORMAT) && go) {
    if (min) {
      go = false;
      setFromDate(moment(min.createdUTC).subtract(35, 'year'));
    }
  }
  var array = document === null || document === void 0 ? void 0 : document.map(function (d) {
    var _a, _b;
    if (!moment(d.createdUTC).isValid()) {
      d.createdUTC = moment(toDate).subtract("hour", 8);
    }
    return {
      label: ((_a = d[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"]) === null || _a === void 0 ? void 0 : _a.includes("Combined Monthly Statement")) ? "Combined Statements" : ((_b = d[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"]) === null || _b === void 0 ? void 0 : _b.includes("Estado de cuenta mensual combinado")) ? "combinar declaraciones" : d[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"],
      value: d.docType
    };
  });
  var docTypeArray = [{
    value: "All",
    label: "All"
  }];
  var map = new Map();
  for (var _i = 0, _l = array || []; _i < _l.length; _i++) {
    var item = _l[_i];
    if (!map.has(item.label)) {
      map.set(item.label, true);
      docTypeArray.push({
        value: item.value,
        label: item.label
      });
    }
  }
  var setFilter = function () {
    var docsss = filterType == "All" ? document === null || document === void 0 ? void 0 : document.filter(function (e) {
      var createdUTCDate = moment(e.createdUTC).format(DATE_FORMAT);
      return moment(createdUTCDate, DATE_FORMAT).isSameOrAfter(fromDate) && moment(createdUTCDate, DATE_FORMAT).isSameOrBefore(toDate);
    }) : document.filter(function (e) {
      var createdUTCDate = moment(e.createdUTC).format(DATE_FORMAT);
      return e.docType == filterType && moment(createdUTCDate, DATE_FORMAT).isSameOrAfter(fromDate) && moment(createdUTCDate, DATE_FORMAT).isSameOrBefore(toDate);
    });
    setFilteredDocs(docsss);
  };
  React.useEffect(function () {
    if (document) {
      setFilterType("All");
      setFilteredDocs(document === null || document === void 0 ? void 0 : document.filter(function (e) {
        var createdUTCDate = moment(e.createdUTC).format(DATE_FORMAT);
        return moment(createdUTCDate, DATE_FORMAT).isSameOrAfter(fromDate) && moment(createdUTCDate, DATE_FORMAT).isSameOrBefore(toDate) && e.docTypeFriendly != "N/A";
      }));
      setPagination(0);
    }
  }, [layout.selectedLoanNumber, page, min === null || min === void 0 ? void 0 : min.createdUTC]);
  var requestADocumentView = function () {
    var _a, _b, _c, _d, _e;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "#FFF",
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        paddingLeft: 20,
        paddingBottom: 20,
        paddingTop: 20,
        borderBottomWidth: 1,
        borderBottomColor: "#e9e9e9"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "column",
        width: matches.small ? "50%" : "15%",
        height: 110
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flexGrow: 1
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, translations.Loan, " ", translations.Number))), /*#__PURE__*/React.createElement(View, {
      style: {
        flexGrow: 1
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, translations.Property, " ", translations.Address)))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: matches.small ? "50%" : "25%"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flexGrow: 1,
        marginLeft: 30
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, layout.selectedLoanNumber))), /*#__PURE__*/React.createElement(View, {
      style: {
        flexGrow: 1,
        marginLeft: 30,
        marginTop: 25
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "".concat((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.propertyAddressLine1)), /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "".concat((_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.propertyLocality, " ").concat((_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.propertyRegion, ", ").concat((_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.propertyPostalCode))))), /*#__PURE__*/React.createElement(View, {
      style: {
        margin: 20
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, translations.RequestDocumentPanelBodyLine1)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, translations.RequestDocumentPanelBodyLine2))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        marginLeft: matches.small ? 10 : 0
      }
    }, requestForms && ((_e = Object.keys(requestForms)) === null || _e === void 0 ? void 0 : _e.length) > 0 && Object.keys(requestForms).map(function (s, i) {
      return /*#__PURE__*/React.createElement(View, {
        key: i,
        style: {
          display: "flex",
          marginLeft: 12,
          marginRight: 8,
          marginBottom: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(View, {
        accessibilityRole: "checkbox"
      }, /*#__PURE__*/React.createElement(PnmacCheckBox, {
        key: "chkRequestForm".concat(i),
        idTag1: "checkbox".concat(i),
        status: requestFormsQue.find(function (d) {
          return d.docId == parseInt(requestForms[s]);
        }) ? 'checked' : 'unchecked',
        onPress: function () {
          return reqForm(s, requestForms[s]);
        }
      })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign({
          marginLeft: matches.small ? 5 : 0,
          fontSize: 14,
          textAlign: "center"
        }, textStyle.formBody)
      }, s))));
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, requestFormsQue.length > 0 ? /*#__PURE__*/React.createElement(PnmacUIButton, {
      idTag1: 'btnRequestSent',
      style: {
        width: "auto",
        marginBottom: 20,
        alignSelf: "center"
      },
      mode: "contained",
      loading: loading && !requestSubmitted,
      onPress: function () {
        setLoading(true);
        postRequest();
      }
    }, requestSubmitted ? "Request Sent" : "Send Request") : null));
  };
  var statementsAndDocumentView = function () {
    var _a, _b, _c;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center",
        paddingTop: 10,
        paddingBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: "#e9e9e9",
        paddingLeft: Platform.OS === 'web' ? 20 : 0
      }
    }, !layout.mobile ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement("label", {
      for: "inputFrom"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "Dates"))) : /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "Dates"), /*#__PURE__*/React.createElement(View, {
      style: layout.mobile ? {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 10,
        marginTop: 10
      } : {
        marginLeft: 5,
        width: 140
      }
    }, /*#__PURE__*/React.createElement(PnmacDatePicker, {
      autoOk: true,
      variant: "inline",
      inputVariant: "outlined",
      format: "d",
      shouldDisableDate: function (date) {
        return null;
      },
      disablePast: false,
      helperText: "Effective data",
      minDate: fromDate,
      maxDate: moment(layout.localTime).add(30, 'day'),
      minDateMessage: "You must select a date greater than today.",
      maxDateMessage: "You must select a date before this date.",
      style: {
        width: Platform.OS === 'web' ? undefined : '70%',
        alignSelf: "center",
        paddingHorizontal: 10,
        borderWidth: 1,
        borderColor: "#707070",
        borderRadius: 10,
        display: "flex",
        flexDirection: "row",
        height: 50
      },
      id: "inputFrom",
      textColor: "#003087",
      value: fromDate,
      onChange: function (fromDates) {
        return setFromDate(fromDates);
      },
      InputAdornmentProps: {
        position: "start"
      },
      animateYearScrolling: true
    })), !layout.mobile ? /*#__PURE__*/React.createElement(View, {
      style: {
        marginHorizontal: 10
      }
    }, /*#__PURE__*/React.createElement("label", {
      for: "inputTo"
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "to"))) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "to")), /*#__PURE__*/React.createElement(View, {
      style: layout.mobile ? {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        marginTop: 10
      } : {
        width: 140
      }
    }, /*#__PURE__*/React.createElement(PnmacDatePicker, {
      autoOk: true,
      variant: "inline",
      inputVariant: "outlined",
      format: "d",
      shouldDisableDate: function (date) {
        return null;
      },
      disablePast: false,
      helperText: "Effective data",
      minDate: fromDate,
      maxDate: moment(layout.localTime).add(30, 'day'),
      minDateMessage: "You must select a date greater than today.",
      maxDateMessage: "You must select a date before this date.",
      style: {
        width: Platform.OS === 'web' ? undefined : '70%',
        alignSelf: "center",
        borderWidth: 1,
        borderColor: "#707070",
        borderRadius: 10,
        display: "flex",
        flexDirection: "row",
        paddingHorizontal: 10,
        height: 50
      },
      id: "inputTo",
      textColor: "#003087",
      value: moment(toDate, DATE_FORMAT),
      onChange: function (toDate) {
        return setToDate(toDate);
      },
      InputAdornmentProps: {
        position: "start"
      },
      animateYearScrolling: true
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginHorizontal: Platform.OS === 'web' ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10,
        marginLeft: 5,
        marginRight: 5,
        marginTop: matches.small ? 10 : undefined
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, translations.DocumentType)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacSelect, {
      accessibilityLabel: "Document type",
      idTag2: 'dropDownDocType',
      useNativeAndroidPickerStyle: Platform.select({
        android: true,
        web: true,
        ios: true
      }),
      key: 'paymentSelect1',
      Icon: layout.mobile && Platform.OS === 'ios' ? function () {
        return /*#__PURE__*/React.createElement(Image, {
          alt: "Click to expand section",
          style: {
            marginTop: 3,
            marginRight: 5,
            width: 12,
            height: 8
          },
          source: require("../assets/expand-icon.png")
        });
      } : function () {
        return null;
      },
      onValueChange: function (value) {
        return setFilterType(value);
      },
      value: filterType,
      items: docTypeArray || [],
      style: {
        viewContainer: __assign({}, layout.mobile ? {
          width: Dimensions.get('window').width * 0.7,
          justifyContent: "center",
          alignItems: "flex-start",
          backgroundColor: "white",
          borderRadius: 10,
          height: 50,
          borderColor: '#707070',
          borderWidth: 1
        } : null),
        inputAndroid: {
          color: "#707070",
          width: '100%',
          paddingLeft: 10,
          paddingRight: 20
        },
        inputIOS: {
          color: "#707070",
          paddingLeft: 10,
          paddingRight: 20
        }
      }
    }))), /*#__PURE__*/React.createElement(View, {
      style: {
        marginLeft: 10,
        marginTop: matches.small ? 20 : "initial"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      idTag1: 'btnFilter',
      mode: "contained",
      style: {
        marginLeft: matches.small ? 0 : 10,
        marginRight: matches.small ? 0 : 20,
        minWidth: "40%"
      },
      onPress: function () {
        setFilter();
      }
    }, "Filter")))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        height: "auto",
        backgroundColor: "#FFF",
        paddingTop: 20,
        paddingBottom: 20,
        borderBottomWidth: 1,
        borderBottomColor: "#e9e9e9"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: '33%',
        marginLeft: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "Doc Name")), /*#__PURE__*/React.createElement(View, {
      style: {
        width: '33%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "Uploaded Date")), /*#__PURE__*/React.createElement(View, {
      style: {
        width: '33%'
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.formBody
    }, "Type"))), layout.mobile ? /*#__PURE__*/React.createElement(View, null, (_a = filteredDocs === null ? document : filteredDocs) === null || _a === void 0 ? void 0 : _a.map(function (e, i) {
      if (e[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"]) {
        return /*#__PURE__*/React.createElement(PnmacRowItem, {
          key: "".concat(i).concat(e[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"]),
          rowContainerStyles: {
            marginTop: 0,
            marginBottom: 0,
            borderBottomWidth: 1,
            borderBottomColor: "#E9E9E9",
            paddingVertical: 20,
            backgroundColor: "#FFF"
          },
          renderChildren: function () {
            return /*#__PURE__*/React.createElement(TouchableOpacity, {
              onPress: function () {
                props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, e.docTypeFriendly + " Viewed", 0);
                fetchPdf(e.docType, e.docId, e.uploaded, e.fileName, (browser === null || browser === void 0 ? void 0 : browser.name) || '', (browser === null || browser === void 0 ? void 0 : browser.version) || '');
              },
              style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                cursor: "pointer"
              }
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                width: '33%',
                marginLeft: 20
              }
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: __assign({}, textStyle.formBody)
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                marginRight: 5
              }
            }, /*#__PURE__*/React.createElement(Image, {
              alt: "Click this icon to download the pdf",
              source: require("../assets/pdf.png"),
              style: layout.mobile ? {} : {
                width: 20,
                height: 20
              }
            })), e[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"])), /*#__PURE__*/React.createElement(View, {
              style: {
                width: '33%'
              }
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: __assign({}, textStyle.formBody)
            }, moment(e.createdUTC).format(DATE_FORMAT))), /*#__PURE__*/React.createElement(View, {
              style: {
                width: '33%'
              }
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: __assign({}, textStyle.formBody)
            }, e.docType)));
          }
        });
      }
    })) : /*#__PURE__*/React.createElement(View, null, (_c = (_b = filteredDocs === null ? document : filteredDocs) === null || _b === void 0 ? void 0 : _b.slice(pagination * 10, pagination * 10 + 10)) === null || _c === void 0 ? void 0 : _c.map(function (e, i) {
      if (e[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"]) {
        return /*#__PURE__*/React.createElement(PnmacRowItem, {
          key: "".concat(i).concat(e[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"]),
          rowContainerStyles: {
            marginTop: 0,
            marginBottom: 0,
            borderBottomWidth: 1,
            borderBottomColor: "#E9E9E9",
            paddingVertical: 20,
            backgroundColor: "#FFF"
          },
          renderChildren: function () {
            return /*#__PURE__*/React.createElement(TouchableOpacity, {
              onPress: function () {
                props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, e.docTypeFriendly + " Viewed", 0);
                fetchPdf(e.docType, e.docId, e.uploaded, e.fileName, (browser === null || browser === void 0 ? void 0 : browser.name) || '', (browser === null || browser === void 0 ? void 0 : browser.version) || '');
              },
              style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                cursor: "pointer"
              }
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                width: '33%',
                flexDirection: "row",
                alignItems: "center",
                marginLeft: 20
              }
            }, /*#__PURE__*/React.createElement(View, {
              style: {
                marginRight: 5
              }
            }, /*#__PURE__*/React.createElement(Image, {
              alt: "Click this icon to download the pdf",
              source: require("../assets/pdf.png"),
              style: layout.mobile ? {} : {
                width: 20,
                height: 20
              }
            })), /*#__PURE__*/React.createElement(PnmacText, {
              style: {
                color: "#000"
              }
            }, e[language == "en" ? "docTypeFriendly" : "docTypeFriendly_ES"])), /*#__PURE__*/React.createElement(View, {
              style: {
                width: '33%'
              }
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: __assign({}, textStyle.formBody)
            }, moment(e.createdUTC).format(DATE_FORMAT))), /*#__PURE__*/React.createElement(View, {
              style: {
                width: '33%'
              }
            }, /*#__PURE__*/React.createElement(PnmacText, {
              style: __assign({}, textStyle.formBody)
            }, e.docType)));
          }
        });
      }
    })));
  };
  return /*#__PURE__*/React.createElement(PnmacSectionListView, {
    noUnderline: true,
    openDefaults: [translations.PanelTitle],
    ref: col,
    data: DATAEXPANDABLE,
    collapsableSections: true,
    renderItem: function (_a, collapsed) {
      var _b, _c, _d, _e;
      var item = _a.item;
      if (collapsed.some(function (s) {
        return s == item.header;
      })) {
        if (item.header === translations.PanelTitle) {
          return document ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
            key: item.header
          }, /*#__PURE__*/React.createElement(View, {
            style: {
              paddingBottom: 20,
              backgroundColor: "#FFF",
              flex: 1,
              justifyContent: "flex-end",
              alignItems: "flex-end"
            }
          }, !layout.pennyWise ? /*#__PURE__*/React.createElement(TouchableOpacity, {
            style: layout.mobile ? {
              width: "50%",
              marginVertical: 10,
              paddingRight: 10,
              alignItems: "flex-end"
            } : {
              width: "100%",
              marginRight: 20,
              alignItems: "flex-end",
              fontSize: 14,
              color: "#003087",
              cursor: "pointer"
            },
            onPress: function () {
              if (layout.mobile) {
                PnmacNavigation(__assign({
                  action: "".concat(layout.pennyHomeUrl, "Account/PaperlessPreferences?ids_token=").concat(layout.token),
                  wind: true,
                  target: "_blank"
                }, props));
              } else {
                PnmacNavigation(__assign({
                  action: {
                    pathname: "/Account/PaperlessPreferences"
                  }
                }, props));
              }
              if (props.layout.drawerOpen) {
                props.dispatch({
                  type: TOGGLE_DRAWER,
                  toggle: false
                });
              }
            }
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.clickableLink
          }, translations.GoPaperlessLinkText)) : null), /*#__PURE__*/React.createElement(View, {
            style: layout.mobile ? {
              backgroundColor: "#fff"
            } : {
              display: "flex",
              backgroundColor: "#FFF",
              flexDirection: "row",
              justifyContent: 'space-between'
            }
          }, /*#__PURE__*/React.createElement(View, {
            style: layout.mobile ? {
              width: "100%"
            } : {
              width: "100%",
              borderBottomWidth: 1,
              borderBottomColor: "#e9e9e9"
            }
          }, /*#__PURE__*/React.createElement(PnmacTabs, {
            small: true,
            style: layout.mobile ? {
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "90%",
              paddingLeft: 10
            } : {
              justifyContent: "flex-start",
              marginLeft: 20,
              marginTop: matches.small ? 20 : 0
            },
            iconStyle: __assign(__assign({}, styles.oneTimePayment.tabPan), textStyle.nonActiveTab),
            selectedIconStyle: __assign({
              height: "auto",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10
            }, textStyle.activeTab),
            selected: page,
            onSelect: function (el) {
              setPage(el.props.name);
            }
          }, /*#__PURE__*/React.createElement(View, {
            key: "Statements",
            name: "Statements"
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: page === "Statements" ? textStyle.activeTabText : textStyle.notificationText
          }, translations.StatementsTabTitle)), /*#__PURE__*/React.createElement(View, {
            key: "Documents",
            name: "Documents"
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: page === "Documents" ? textStyle.activeTabText : textStyle.notificationText
          }, translations.DocumentsTabTitle)), !layout.pennyWise && requestForms && ((_b = Object.keys(requestForms)) === null || _b === void 0 ? void 0 : _b.length) > 0 ? /*#__PURE__*/React.createElement(View, {
            key: "RequestADocument",
            name: "RequestADocument"
          }, /*#__PURE__*/React.createElement(PnmacText, {
            style: page === "RequestADocument" ? textStyle.activeTabText : textStyle.notificationText
          }, translations.RequestDocumentPanelTitle)) : page === "RequestADocument" ? setPage("Statements") : null))), requestForms && ((_c = Object.keys(requestForms)) === null || _c === void 0 ? void 0 : _c.length) > 0 && page === "RequestADocument" ? requestADocumentView() : statementsAndDocumentView()), /*#__PURE__*/React.createElement(View, {
            style: {
              backgroundColor: "#FFF",
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              display: "flex",
              paddingBottom: 20,
              alignItems: "center",
              justifyContent: "center"
            }
          }, layout.mobile || page === "RequestADocument" ? null : /*#__PURE__*/React.createElement(PnmacPagination, {
            style: {
              marginTop: 20
            },
            onChange: function (e, p) {
              return setPagination(p - 1);
            },
            page: pagination + 1,
            count: (document === null || document === void 0 ? void 0 : document.length) % 10 == 0 ? parseInt(((_d = filteredDocs || document) === null || _d === void 0 ? void 0 : _d.length) / 10) : parseInt(((_e = filteredDocs || document) === null || _e === void 0 ? void 0 : _e.length) / 10) + 1,
            variant: "outlined",
            shape: "rounded",
            color: "primary"
          }))) : /*#__PURE__*/React.createElement(View, null, layout.mobile ? null : /*#__PURE__*/React.createElement(LinearBuffer, null));
        } else {}
      } else {
        return null;
      }
    },
    renderSectionHeader: function (_a) {
      var _b, _c;
      var title = _a.section.title;
      var open = ((_b = col === null || col === void 0 ? void 0 : col.current) === null || _b === void 0 ? void 0 : _b.state.collapsed.indexOf(title)) > -1;
      return /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
        rowHeaderContainerStyles: __assign(__assign({}, styles.rowHeaderContainerStyles), {
          borderBottomWidth: open ? 1 : 0,
          borderBottomColor: "#e9e9e9",
          borderBottomLeftRadius: open ? 0 : 10,
          borderBottomRightRadius: open ? 0 : 10,
          marginBottom: 0
        }),
        onClickExpand: function () {
          return col === null || col === void 0 ? void 0 : col.current.collapseItem(title);
        },
        item: /*#__PURE__*/React.createElement(PnmacText, {
          id: title,
          style: textStyle.formTitleSection
        }, title),
        isExpand: ((_c = col === null || col === void 0 ? void 0 : col.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1
      });
    }
  });
};
var StatementsAndDocuments = /** @class */function (_super) {
  __extends(StatementsAndDocuments, _super);
  function StatementsAndDocuments() {
    var _this = _super.call(this) || this;
    _this.fetchPdf = function (docType, docId, uploaded, fileName, browserName, browserVersion) {
      var _a, _b, _c;
      var layout = _this.props.layout;
      fetch("".concat(_this.props.layout.pennyHomeUrl, "api/documents/").concat(_this.props.layout.mobile ? "get_docs_stream_download" : "get_docs_stream"), {
        body: JSON.stringify({
          docId: docId,
          loanId: layout.selectedLoanNumber,
          docType: docType,
          uploadDate: uploaded,
          trackerURL: ((_a = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _a === void 0 ? void 0 : _a.pathname) || null,
          filName: fileName,
          emailAddress: (_b = layout.userProfile) === null || _b === void 0 ? void 0 : _b.verified_email,
          username: (_c = layout.userProfile) === null || _c === void 0 ? void 0 : _c.username
        }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': "Bearer ".concat(layout.token)
        }
      }).then(function (response) {
        if (_this.props.layout.mobile) {
          return response.text();
        }
        return response.blob();
      }).then(function (response) {
        if (_this.props.layout.mobile) {
          PnmacNativeFetch(response, fileName);
        } else {
          var blob = new Blob([response], {
            type: 'application/pdf'
          });
          var downloadUrl = URL.createObjectURL(blob);
          if (browserName === 'Safari' && browserVersion >= 13 && browserVersion < 15) {
            var a = document.createElement("a");
            a.href = downloadUrl;
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
          } else {
            window.open(downloadUrl, "_blank");
          }
        }
      }).catch(function (err) {
        return console.log(err);
      });
    };
    _this.state = {
      docId: 0,
      documentView: false,
      requestForms: {},
      requestFormsQue: [],
      requestSubmitted: false,
      docType: null,
      uploaded: null,
      fileName: null,
      trackerURL: null,
      trackersessionId: 0,
      open: false
    };
    return _this;
  }
  StatementsAndDocuments.getDerivedStateFromProps = function (props, state) {
    // Any time the current user changes,
    // Reset any parts of state that are tied to that user.
    // In this simple example, that's just the email.
    var _a, _b, _c, _d;
    if (((_b = (_a = props.layout) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.availableDcos) !== state.requestForms) {
      return {
        requestForms: (_d = (_c = props.layout) === null || _c === void 0 ? void 0 : _c.documents) === null || _d === void 0 ? void 0 : _d.availableDcos
      };
    }
    return null;
  };
  StatementsAndDocuments.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      translations = _b.translations,
      layout = _b.layout;
    var _c = this.state,
      requestForms = _c.requestForms,
      requestFormsQue = _c.requestFormsQue,
      requestSubmitted = _c.requestSubmitted;
    var yearEnd = layout === null || layout === void 0 ? void 0 : layout.yearEndData;
    var trackerSession = ((_a = this.props) === null || _a === void 0 ? void 0 : _a.layout).trackerSession;
    var yearEnddBannerdisplayMonth = moment().format("MM");
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          marginHorizontal: 10,
          marginTop: -10
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.statementsDocuments
      }), /*#__PURE__*/React.createElement(TransitionsModal, {
        matches: matches,
        translations: translations,
        open: _this.state.open,
        closeModal: function () {
          return _this.setState({
            open: false
          });
        }
      }), yearEnddBannerdisplayMonth == "12" || yearEnddBannerdisplayMonth <= "04" ? yearEnd != null && yearEnd.isX ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 10
        },
        type: 'warning'
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        navigation: _this.props.navigation,
        value: (_a = translations.TaxBannerX) === null || _a === void 0 ? void 0 : _a.replace("{0}", yearEnddBannerdisplayMonth == "12" ? moment().format("YYYY") : moment().subtract(1, 'year').format("YYYY"))
      })) : yearEnd != null && yearEnd.isE ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 10
        },
        type: 'warning'
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        value: translations.TaxBannerE
      })) : /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 10
        },
        type: 'warning'
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        navigation: _this.props.navigation,
        value: (_b = translations.TaxBannerNotI40I30XE) === null || _b === void 0 ? void 0 : _b.replace("{0}", yearEnddBannerdisplayMonth == "12" ? moment().format("YYYY") : moment().subtract(1, 'years').format("YYYY")).replace("{1}", yearEnddBannerdisplayMonth == "12" ? moment().add(1, 'years').format("YYYY") : moment().format("YYYY"))
      })) : null, /*#__PURE__*/React.createElement(StateMentInfo, __assign({
        requestSubmitted: requestSubmitted,
        postRequest: function () {
          return __awaiter(_this, void 0, void 0, function () {
            var dataDocs, jsDataDocs, i, error_1;
            var _a;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  _b.trys.push([0, 4,, 5]);
                  if (!(parseInt((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId) > 0)) return [3 /*break*/, 3];
                  this.setState({
                    requestSubmitted: false
                  });
                  requestFormsQue.forEach(function (s) {
                    var _a;
                    return s.loanId = (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId;
                  });
                  return [4 /*yield*/, fetch("".concat(layout.pennyHomeUrl, "api/documents/request_docs"), {
                    method: "POST",
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': "Bearer ".concat(layout === null || layout === void 0 ? void 0 : layout.token)
                    },
                    body: JSON.stringify(requestFormsQue)
                  })];
                case 1:
                  dataDocs = _b.sent();
                  return [4 /*yield*/, dataDocs.json()];
                case 2:
                  jsDataDocs = _b.sent();
                  if (jsDataDocs) {
                    this.props.refreshMessages();
                    for (i = 0; i < requestFormsQue.length; i++) {
                      delete requestForms[requestFormsQue[i].docTypeCategory];
                    }
                    this.setState({
                      requestSubmitted: true,
                      requestFormsQue: [],
                      requestForms: requestForms,
                      open: true
                    });
                  }
                  _b.label = 3;
                case 3:
                  return [3 /*break*/, 5];
                case 4:
                  error_1 = _b.sent();
                  console.error(error_1);
                  return [3 /*break*/, 5];
                case 5:
                  return [2 /*return*/];
              }
            });
          });
        },
        reqForm: function (call, V) {
          var _a, _b;
          var requestFormsQue = _this.state.requestFormsQue;
          if (requestFormsQue.find(function (s) {
            return s.docId == V;
          })) {
            requestFormsQue.splice(requestFormsQue.findIndex(function (s) {
              return s.docId == V;
            }), 1);
          } else {
            requestFormsQue.push({
              docTypeCategory: call,
              effectiveUTC: moment().format(DATE_FORMAT),
              createdUTC: moment().format(DATE_FORMAT),
              loanId: (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId,
              trackerURL: ((_b = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _b === void 0 ? void 0 : _b.pathname) || null,
              trackersessionId: trackerSession,
              docId: V,
              docTypeId: V
            });
          }
          _this.setState({
            requestFormsQue: requestFormsQue
          });
        },
        requestForms: requestForms,
        requestFormsQue: requestFormsQue,
        matches: matches,
        fetchPdf: _this.fetchPdf
      }, _this.props)));
    });
  };
  return StatementsAndDocuments;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(StatementsAndDocuments, function (props) {
  return props.translations.statementsDocuments;
}));